import * as stylex from '@stylexjs/stylex'
import { type Theme as StyleXTheme, type VarGroup } from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef } from 'react'
import { PortalProvider } from '../PortalProvider/PortalProvider'
import { colors } from '../tokens/colors.stylex'
import { typography } from '../tokens/typography.stylex'

const baseStyles = stylex.create({
  root: {
    interpolateSize: 'allow-keywords',
    color: colors.grey900,
    fontFamily: typography.font,
    fontSize: typography.sizeBody,
    fontWeight: typography.weightRegular,
  },
})

export type Theme<K> = StyleXTheme<VarGroup<{
  [key in keyof K]: string
}>>

export interface ThemeProviderProps<K> extends ComponentPropsWithoutRef<'div'> {
  /** StyleX 主題物件，定義色彩 token 的對應值 */
  theme: Theme<K>
  /** 自訂根元素的 StyleX 樣式 */
  rootStyle?: stylex.StyleXStyles
}

/**
 * ThemeProvider 是主題提供者元件，套用 StyleX 主題變數與基礎排版樣式。
 * 內部包含 PortalProvider，確保 Portal 內容也能繼承主題。
 */
export const ThemeProvider = <K,>(props: ThemeProviderProps<K>) => {
  const { theme, rootStyle, children, ...rest } = props
  const themeProps = stylex.props(baseStyles.root, theme, rootStyle)

  return (
    <div {...themeProps} {...rest}>
      <PortalProvider themeProps={themeProps}>
        {children}
      </PortalProvider>
    </div>
  )
}
